import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Stack,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { toast } from "react-toastify";
import axios from "axios";
import { serverUrl } from "../../server";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";

const defaultTheme = createTheme();

const UpdateTracteur = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [immat, setImmat] = useState('');
  const [proprioId, setProprioId] = useState('');
  const [propriosOptions, setPropriosOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const getProprios = async () => {
    const token = Cookies.get('jwt');
    try {
      const response = await axios.get(`${serverUrl}/api/proprio/getproprios`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPropriosOptions(response.data.proprios);
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors du chargement des propriétaires');
    }
  };

  const getTracteurDetails = async () => {
    const token = Cookies.get('jwt');
    try {
      const response = await axios.get(`${serverUrl}/api/tracteur/gettracteur/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const tracteur = response.data;
      setImmat(tracteur.immat);
      setProprioId(tracteur.proprio_id);
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors du chargement des détails du tracteur');
      navigate('/dashboard/tracteur');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProprios();
    getTracteurDetails();
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = Cookies.get('jwt');
    const data = {
      immat: immat,
      proprio_id: proprioId,
    };

    try {
      const response = await axios.post(
        `${serverUrl}/api/tracteur/updatetracteur/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success('Tracteur mis à jour avec succès', {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate('/dashboard/tracteur');
      } else {
        toast.error(response.data.message || 'Erreur lors de la mise à jour');
      }
    } catch (error) {
      console.error(error);
      toast.error('Erreur lors de la mise à jour du tracteur');
    }
  };

  if (loading) {
    return (
      <Container component="main" maxWidth="xs">
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography>Chargement...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <Box sx={{ mt: 3, mb: 3 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Modifier un Tracteur
          </Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Stack spacing={3}>
            <TextField
              required
              fullWidth
              id="immat"
              label="Immatriculation"
              name="immat"
              autoFocus
              value={immat}
              onChange={(e) => setImmat(e.target.value)}
            />
            <Box>
              <InputLabel id="proprioId-label">Propriétaire</InputLabel>
              <Select
                labelId="proprioId-label"
                id="proprioId"
                value={proprioId}
                onChange={(e) => setProprioId(e.target.value)}
                fullWidth
              >
                {propriosOptions.map((proprio) => (
                  <MenuItem key={proprio.id} value={proprio.id}>
                    {proprio.nom}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
              >
                Mettre à jour
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default UpdateTracteur;
